import { useContext, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { downloadCABIEFile } from '../../api/newLoad';
import DownloadIcon from '../../images/download.svg';
import DataTable from '../DataTable';
import { PreferentialTooltip } from '../Newload/ProductInfo/Tooltips';
import { StoreContext } from '../Store';
import Tooltip from '../Tooltip/Tooltip';
import IpaffsModaltable from './IpaffsModalTable';

const IpaffsModalConsolidatedViewReadOnly = ({ data }) => {
  const { loadId, portalRef } = useContext(StoreContext);
  const [isDownloadingFile, setIsDownloadingFile] = useState(false);

  const onDownloadClick = async (origin, hsCodes) => {
    setIsDownloadingFile(true);
    await downloadCABIEFile({ loadId: loadId[0], fileName: `IPAFFS-${portalRef[0]}-${origin}`, origin, hsCodes });
    setIsDownloadingFile(false);
  };

  const DownloadIconImage = (
    <div>
      <img src={DownloadIcon} alt="Download" />
    </div>
  );

  return (
    <IpaffsModaltable data={data ?? []}>
      <DataTable.Column colKey={'riskCategory'} key={'riskCategory'} header={'IPAFFS Risk Category'} />
      <DataTable.Column colKey={'origin'} key={'origin'} header={'Origin'} />
      <DataTable.Column colKey="ipaffsCodes" key="ipaffsCodes" header="IPAFFS HS Codes">
        {(row) => {
          return <>{row?.ipaffsHSCodes?.join(', ') ?? ''}</>;
        }}
      </DataTable.Column>
      <DataTable.Column colKey={'consolidatedIpaffs'} key={'consolidatedIpaffs'} header={'CHED Ref'} />
      <DataTable.Column
        colKey="ipaffsFile"
        header="IPAFFS File"
        style={{ height: '1px', padding: 0 }}
        tooltip={
          <PreferentialTooltip>
            <p>Select the download icon to download Low risk IPAFFS data</p>
          </PreferentialTooltip>
        }
        maxWidth="4ch"
      >
        {(row) => {
          if (row.riskCategory !== 'Low') {
            return null;
          }

          if (!loadId[0]) {
            return (
              <div className="d-flex align-items-center justify-content-center h-100 px-3">
                <Tooltip icon={<div>{DownloadIconImage}</div>}>
                  <p className="text-center">Please Save as Draft in order to download the IPAFFS file.</p>
                </Tooltip>
              </div>
            );
          }

          return (
            <div className="d-flex align-items-center h-100 px-3">
              <button
                className="external-table-link"
                onClick={() => onDownloadClick(row.origin, row.hsCodes)}
                disabled={isDownloadingFile}
              >
                {isDownloadingFile ? <Spinner animation="border" size="sm" /> : DownloadIconImage}
              </button>
            </div>
          );
        }}
      </DataTable.Column>
    </IpaffsModaltable>
  );
};

export default IpaffsModalConsolidatedViewReadOnly;
